import { HeadData } from '@/components/HeadData';
import type { FragmentType } from '@/gql/codegen';
import { StartPage } from '@/routes/_embaUserLayout/-components/StartPage';
import type React from 'react';
import { useState } from 'react';
import { CourseLessonGoalSettingPageComponent } from '..';
import type { COURSE_LESSON_GOAL_SETTING_FRAGMENT } from '../index';
import { useAnswerGoalSettingMutation } from './-hooks/useAnswerGoalSettingMutation';

export type CourseLessonGoalSettingContainerProps = {
  content: FragmentType<typeof COURSE_LESSON_GOAL_SETTING_FRAGMENT>;
  lessonName: string;
  chapterName: string;
  userAttendanceSlug: string;
  lessonSlug: string;
  onEmbaStartCourseLesson: () => Promise<void>;
  onEmbaCompleteCourseLesson: () => Promise<void>;
  headTitle: string;
};

export const CourseLessonGoalSettingContainer = ({
  content,
  lessonName,
  chapterName,
  userAttendanceSlug,
  lessonSlug,
  onEmbaStartCourseLesson,
  onEmbaCompleteCourseLesson,
  headTitle,
}: CourseLessonGoalSettingContainerProps) => {
  const [processState, setProcessState] = useState<'start' | 'in progress'>(
    'start',
  );

  const {
    answerGoalSetting,
    answerGoalSettingError,
    answerGoalSettingLoading,
    isAnsweredModalOpen,
    closeAnsweredModal,
  } = useAnswerGoalSettingMutation(userAttendanceSlug, lessonSlug);

  if (answerGoalSettingError) {
    throw answerGoalSettingError;
  }

  const startLesson = () => {
    onEmbaStartCourseLesson();
    setProcessState('in progress');
  };

  return (
    <>
      <HeadData title={headTitle} />
      {processState === 'start' ? (
        <StartPage
          onClick={startLesson}
          chapterName={chapterName}
          lessonName={lessonName}
          lessonType="goal_setting"
        />
      ) : (
        <CourseLessonGoalSettingPageComponent
          content={content}
          lessonName={lessonName}
          chapterName={chapterName}
          onEmbaCompleteCourseLesson={onEmbaCompleteCourseLesson}
          answerGoalSetting={answerGoalSetting}
          answerGoalSettingLoading={answerGoalSettingLoading}
          isAnsweredModalOpen={isAnsweredModalOpen}
          closeAnsweredModal={closeAnsweredModal}
        />
      )}
    </>
  );
};
